"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemUnitAmountToString = exports.ingredientToString = exports.ingredientToParts = exports.igToNameWithKeyword = void 0;
const addPrettyFractionsToText_1 = require("./addPrettyFractionsToText");
exports.igToNameWithKeyword = (ig) => {
    var _a;
    if (!("editedByUser" in ig) ||
        !ig.editedByUser ||
        !ig.keyword || ((_a = ig.name) === null || _a === void 0 ? void 0 : _a.includes(ig.keyword))) {
        return ig.name;
    }
    return ig.name ? `${ig.keyword} ${ig.name}` : ig.keyword;
};
exports.ingredientToParts = (ig) => {
    let amountAndUnit = "";
    if (ig.amount) {
        amountAndUnit = addPrettyFractionsToText_1.addPrettyFractionsToText(ig.amount);
    }
    if (ig.unit) {
        const lastChar = amountAndUnit.charAt(amountAndUnit.length - 1);
        if (ig.amount &&
            (ig.unit.length >= 3 ||
                !(lastChar >= "0" && lastChar <= "9") ||
                ig.unit.endsWith("."))) {
            amountAndUnit += " ";
        }
        amountAndUnit += ig.unit;
        amountAndUnit += " ";
    }
    else if (ig.amount) {
        amountAndUnit += " ";
    }
    const name = exports.igToNameWithKeyword(ig);
    return {
        amountAndUnit,
        rest: name ? addPrettyFractionsToText_1.addPrettyFractionsToText(name) : "",
    };
};
exports.ingredientToString = (x) => {
    if ("text" in x) {
        return x.text;
    }
    const parts = [];
    if (x.amount) {
        parts.push(x.amount);
    }
    if (x.unit) {
        if (x.unit === "g" && parts.length === 1) {
            parts[0] += x.unit;
        }
        else {
            parts.push(x.unit);
        }
    }
    const actualName = exports.igToNameWithKeyword(x);
    if (actualName) {
        parts.push(actualName);
    }
    return parts.join(" ");
};
exports.itemUnitAmountToString = (item) => `${item.amount ? `${item.amount} ` : ""}${item.unit || ""}`;
//# sourceMappingURL=ingredientToString.js.map